import React from "react";

import { CollapsibleTab, StaticTab } from "./Tab";

const TabsContainer = ({ activeTabIndex, onTabHover, tabData }) => {
  return (
    <div className="flex justify-center items-center w-full h-[407px] relative max-sm:flex-col max-md:h-fit">
      {/* Desktop Tabs with animation */}
      <div
        className={`absolute top-0 left-0 z-10 transition-all duration-300 ease-in-out ${
          activeTabIndex === 0 ? "w-[70%] h-full" : "w-0 h-full"
        } max-md:hidden`}
        style={{
          overflow: "hidden",
        }}
      >
        <div className="flex flex-col bg-white pl-[45px] pt-[45px] w-full h-full">
          <p className="text-black text-[40px] text-left leading-[1.1]">
            Introducing
          </p>
          <p
            className="transition-all duration-300 ease-in-out transform text-black text-[170px] text-left font-light leading-[1.1]"
            style={{
              transform:
                activeTabIndex === 0
                  ? "translate(0, 0) scale(1)"
                  : "translate(calc(45px - 50%), calc(45px - 50%)) scale(0.2)",
              letterSpacing: "-0.1em",
            }}
          >
            OM1
          </p>
          <p className="text-black text-[40px] text-left font-creato max-w-[650px] tracking-[-0.4px] leading-[1.1]">
            Our first open-source, agentic Operating System for Robotics.
          </p>
        </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full z-0 max-md:hidden">
        <nav className="w-full h-full right-0">
          {tabData.map((tab, index) => (
            <CollapsibleTab
              key={tab.id}
              heading={tab.heading}
              label={tab.label}
              content={tab.content}
              onMouseEnter={() => onTabHover(index + 1)}
              onMouseLeave={() => onTabHover(0)}
              activeTabIndex={activeTabIndex}
              index={index + 1}
              backgroundColor={tab.backgroundColor}
              textColor={tab.textColor}
              collapsedWidth={tab.collapsedWidth}
              href={tab.href}
            />
          ))}
        </nav>
      </div>
      {/* Mobile/Tablet Tabs without animation */}
      <div className="flex max-sm:flex-col md:flex-row w-full h-full lg:hidden">
        <div className="flex flex-col bg-white max-sm:justify-center max-sm:items-center px-[40px] py-[45px] w-full md:w-[60%] sm:py-[20px]">
          <p className="text-black text-[20px] text-center sm:text-left leading-[1.1]">
            Introducing
          </p>
          <p className="text-black text-[100px] text-center sm:text-left font-light leading-[1.1] tracking-[-0.1em] mr-8">
            OM1
          </p>
          <p className="text-black text-[20px] max-w-[300px] text-center sm:text-left font-creato max-w-[650px] tracking-[-0.4px] leading-[1.1]">
            Our first open-source, agentic Operating System for Robotics.
          </p>
        </div>
        <div className="flex flex-col w-full md:w-[40%]">
          {tabData.map(({ id, label, backgroundColor, textColor, href }) => (
            <StaticTab
              key={id}
              label={label}
              backgroundColor={backgroundColor}
              textColor={textColor}
              href={href}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabsContainer;
